import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=fabe0b44&scoped=true&"
import script from "./PackageCard.vue?vue&type=script&lang=ts&"
export * from "./PackageCard.vue?vue&type=script&lang=ts&"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=fabe0b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe0b44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClientOnlyPrice: require('/opt/build/repo/apps/shop/components/ClientOnlyPrice.vue').default,FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,LinkButton: require('/opt/build/repo/apps/shop/components/storyblok/LinkButton/LinkButton.vue').default})
